import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { MainService } from '../main.service';

export interface MemberLookupResult {
  success: boolean;
  matasId: string | null;
  storeId: number | null;
  storeName: string | null;
  validEmail: boolean | null;
  permissionStore: boolean | null;
  permissionClubMatas: boolean | null;
  communicationsHistoryEntries:
    | MemberLookupResultCommmunicationsHistoryEntry[]
    | null;
}

export interface MemberLookupResultCommmunicationsHistoryEntry {
  name: string;
  sentAt: string;
}

@Injectable({
  providedIn: 'root',
})
export class MemberLookupService {
  constructor(private http: HttpClient, private mainService: MainService) {}

  lookupMember(email: string): Observable<MemberLookupResult> {
    return this.http
      .get<MemberLookupResult>(
        this.mainService.getApiURL() +
          'MemberLookup?email=' +
          encodeURIComponent(email),
        {
          headers: this.mainService.getHeaders(),
        }
      )
      .pipe(
        map((r) => {
          r.success = true;
          return r;
        }),
        catchError((e) => {
          if (e.status == 404) {
            return of({
              success: false,
              matasId: null,
              storeId: null,
              storeName: null,
              validEmail: null,
              permissionStore: null,
              permissionClubMatas: null,
              communicationsHistoryEntries: null,
            });
          } else {
            throw e;
          }
        })
      );
  }
}
